import Vue from "vue";
import { Api } from "../../plugins/api";
import axios from "axios";
import moment from "moment";

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;

export default {
  label: {
    JustifRequis:"Un document justificatif sera requis pour la soumission de votre candidature.",
    ResultatSoumis:"Résultats du Bac soumis avec succès.",
    HintCodeMassar:"Veuillez saisir votre code Massar et non pas votre mot de passe Massar.",
    UneErreurEstSurvenue:
      "Une erreur est survenue lors de l'enregistrement de votre inscription",
    ProgrammeMinimum: "Veuillez sélectionner au moins un programme ou vérifiez le nombre de spécialités sélectionnées.",
    ChampsAnnexesObligatoires:"Merci de renseigner tous les champs/annexes obligatoires",
    ChampsObligatoires: "Merci de renseigner les champs obligatoires",
    AnnexesManquantes:
      "Merci d'ajouter toutes les annexes obligatoires ou non conforme.",
    ValiderNotes: "Valider les notes",
    ReadOnly: "La date de soumission de votre inscription est passée.",
    DateClotureInge:
      'Date de cloture du formulaire pour le cycle "ingénieur" : ',
    DateClotureMaster:
      'Date de cloture du formulaire pour le cycle "master" : ',
    DateClotureParallele:
      'Date de cloture du formulaire pour le cycle "parallèle" : ',
    DateCloturePostBacFr:
      'Date de cloture du formulaire pour le cycle "PostBac français" : ',
    DateCloturePostBacMa:
      'Date de cloture du formulaire pour le cycle "PostBac marocain" : ',
    DateCloturePostBacAu:
      'Date de cloture du formulaire pour le cycle "PostBac autre" : ',
    Introduction: "Création de compte",
    SauverFormulaire: "Sauvegarder",
    SoumettreCandidature: "Soumettre ma candidature",
    MathsExpertNote: "Maths Expert Note",
    InformationsPersonnelles: "Informations personnelles",
    InformationAnnexes: "Annexes",
    InformationResume: "Récapitulatif",
    InformationsScolaire: "Informations académiques",
    InformationLicence: "Informations sur le Parcours Post-Bac",
    DiplomeActuel: "Votre cursus actuel",
    DiplomePostule: "Cycle souhaité",
    Programmes: "Sélection des programmes",
    ObtentionBac: "Avez-vous terminé votre cursus?",
    NoteMasterEtProgIngenieur: "Notes et Nombre de rattrapages (la dernière année si disponible)",
    ExplicationNbDeRattrapage: "Nb de rattrapages = Nombre de rattrapages",
    Genre: "Genre",
    Nom: "Nom de famille",
    Prenom: "Prénom(s)",
    AddressTuteur: "Adresse tuteur",
    InfoTuteur: "Informations Tuteur",
    Email: "Email",
    ConfirmationEmail: "Ressaisir votre Email",
    TelPortable: "Téléphone",
    NumPassport: "Passeport",
    ConfirmationNumPassport: "Ressaisir Passeport",
    Pays: "Pays",
    PaysResidence: "Pays de résidence",
    EtesVousSportifHautNiveau: "Êtes-vous un sportif de haut niveau ?",
    Discipline: "Discipline",
    CIN: "Carte d'identité nationale (CNIE) ",
    ConfirmationCIN: "Ressaisir Carte d'identité nationale (CNIE)",
    DateDeNaissance: "Date de naissance (jj/mm/aaaa)",
    PaysNaissance: "Nationalité 1",
    EtrangerVivantAuMaroc: "Résident étranger au Maroc",
    EmployeEtatMarocain: "Employé de l'Etat marocain",
    SituationFamilial: "Situation familiale",
    Handicap: "Besoins spécifiques - Handicap",
    InformationPostal: "Coordonnées téléphoniques et postales:",
    SportifHautNiveau: "Sportif haut niveau",
    Addresse: "Adresse",
    Addresse2: "Adresse 2",
    Region: "Région",
    RegionAutre: "Précisez votre région",
    District: "Province",
    RelationCandidatTuteur: "Lien de parenté entre le candidat et le tuteur",
    Ville: "Ville",
    CodePostal: "Code postal",
    Telephone: "Téléphone",
    Telephone1: "Téléphone 1",
    Telephone2: "Téléphone 2",
    TypeLicence: "Type Licence",
    InformationTuteur:
      "Veuillez nous fournir les coordonnées valides de votre tuteur légal:",
    Profession: "Profession",
    MemeAddressTuteur: "Utiliser l'adresse du candidat?",
    SelectionProgramme: "Sélection des programmes:",
    InformationBac: "Informations sur le baccalauréat",
    TypeDeBac: "Type de baccalauréat",
    TypeDeBacAutre: "Précisez le type de bac",
    CodeEtudiant: "Code Massar",
    InformationBachelier: "Informations Bachelier:",
    VotreDiplomeActuel: "Votre diplôme actuel (en cours ou obtenu)",
    DiplomeTermine: "Êtes-vous déjà titulaire d'un diplôme de baccalauréat ?",
    PaysObtentionDiplome: "Pays d'obtention du diplôme",
    PaysEtablissement: "Pays d'établissement",
    VilleObtenionDiplome: "Ville d'établissement",
    VilleEtablissement: "Ville du lycée",
    PaysLycee: "Pays du lycée",
    NomEtablissement: "Nom du lycée",
    NomEtablissementMaster: "Nom d'établissement",
    VilleEtablissementAutre: "Précisez la ville du lycée si pas dans la liste",
    NomEtablissementAutre: "Précisez le nom du lycée si pas dans la liste",
    TypeEtablissement: "Public/Privé",
    Major: "Filière",
    DateEntree: "Date d'entrée",
    DateFin: "Date de fin (ou prévue)",
    EchelleNotation: "Votre barème de notation",
    EchelleNotationPrecision: "Veuillez préciser votre échelle de notation",
    DocumentsCandidat: "Documents Candidat:",
    DocumentBac: "Documents Bac:",
    PhotoCandidat: "Photo candidat",
    CarteIdentite: "Carte Identité (ou passeport)",
    DiplomeBac: "Diplome Bac",
    ReleveNoteBac: "Notes Lycée",
    DocumentSpecifique: "Documents spécifique",
    LettreMotivation: "Lettre motivation",
    CuriculumVitae: "Votre CV",
    LettreRecommendation1: "Lettre de recommandation 1",
    LettreRecommendation2: "Lettre de recommandation 2",
    CertificationHonneur: "Engagement sur l'honneur",
    CndpClause:
      "J'ai lu et j'accepte les conditions générales d'utilisation, notamment la mention relative à la protection des données personnelles.",
    ResidentEtrangeMaroc: "Résident étranger au Maroc",
    ConnaissanceFirsi: "Comment avez-vous eu connaissance de l'UM6P?",
    VilleNaissance: "Ville de naissance",
    PrecisionVilleNaissance: "Précisez votre ville de naissance",
    ChoixDiplome: "Cycle souhaité",
    ChoixCycle: "Choix du cycle",
    LienCharte:
      '<a href="https://um6p.ma/fr/conditions-generales-dutilisation" target="_blank">Cliquez ici pour consulter la charte</a>',
    NatureHandicap: "Veuillez préciser votre handicap",
    TelechargerDocument: "Téléchargement de documents",
    FiliereDuBac: "Domaine du baccalauréat",
    PreciserFiliereDuBac: "Preciser filiere du bac",
    MoyGen2eCycleLycee: "Moyenne 2e année cycle lycée",
    AnneeObtentionBac: "Année d'obtention du bac",
    MoyGenAnnuelleBac: "Moyenne générale du Bac",
    MoyGenAnnuelleBacAutre: "Moyenne générale du Bac",
    NoteExamenNational: "Note de l'Examen National",
    NoteMathPhysique:
      "Veuillez saisir vos notes de mathématiques et de physique",
    NoteMathPhysiqueNational:
      "Please enter Maths & Physics grades: > Physics > National exam grade",
    InfoPerso: "Informations personnelles",
    Spécialite1: "Spécialité 1",
    Specialite2: "Spécialité 2",
    MathsExpertOption: "Option Maths Expert",
    Specialite1note: "Spécialité 1 Note",
    Specialite2note: "Spécialité 2 Note",
    MoyenneGenDiplome: "Degree average grade",
    BaremeNote: "Votre barème de notation au Bac",
    SpecificationBaremBac: "Précisez votre barème",
    NbrRattrapages1: "Nb rattrapage s1",
    NbrRattrapages2: "Nb rattrapage s2",
    NbrRattrapages3: "Nb rattrapage s3",
    NbrRattrapages4: "Nb rattrapage s4",
    NbrRattrapages5: "Nb rattrapage s5",
    NbrRattrapages6: "Nb rattrapage s6",
    NbrRattrapages7: "Nb rattrapage s7",
    NbrRattrapages8: "Nb rattrapage s8",
    NbrRattrapages9: "Nb rattrapage s9",
    NbrRattrapages10: "Nb rattrapage s10",
    NbrRattrapages11: "Nb rattrapage s11",
    NbrRattrapages12: "Nb rattrapage s12",
    Semestre1: "Semestre 1",
    Semestre2: "Semestre 2",
    Semestre3: "Semestre 3",
    Semestre4: "Semestre 4",
    Semestre5: "Semestre 5",
    Semestre6: "Semestre 6",
    Semestre7: "Semestre 7",
    Semestre8: "Semestre 8",
    Semestre9: "Semestre 9",
    Semestre10: "Semestre 10",
    Semestre11: "Semestre 11",
    Semestre12: "Semestre 12",
    Math1BacSem1: "Maths Année du Bac - Sem 1/Trim 1",
    Math1BacSem1Autre: "Maths 2° Année Cycle Lycée Sem1/Trim1",
    Math1BacSem2: "Maths Année du Bac - Sem 2/Trim 2",
    Math1BacSem2Autre: "Maths 2° Année Cycle Lycée Sem2/Trim2",
    Math2BacSem1: "Maths 2° Année Cycle Lycée - Sem 1/Trim1",
    Math2BacSem1Autre: "Maths Année du Bac Sem1/Trim1",
    Math2BacSem2: "Maths 2e Bac-Sem 2",
    Math2BacSem2Autre: "Maths Année du Bac Sem2/Trim2",
    MathNational: "Maths National",
    Physique1BacSem1: "Physique Année du Bac - Sem 1/Trim1",
    Physique1BacSem1Autre: "Physique 2° Année Cycle Lycée Sem1/Trim1",
    Physique1BacSem2: "Physique 1er Bac-Sem 2",
    Physique1BacSem2Autre: "Physique 2° Année Cycle Lycée Sem2/Trim2",
    Physique2BacSem1: "Physique 2e Bac-Sem 1",
    Physique2BacSem1Autre: "Physique Année du Bac Sem1/Trim1",
    Physique2BacSem2: "Physique 2e Bac-Sem 2",
    Physique2BacSem2Autre: "Physique Année du Bac - Sem 2/Trim 2",
    PhysiqueNational: "Physique National",
    DateEntreeLicence: "Date entrée",
    NoteFinalDiplome: "Moyenne générale du diplôme",
    MoyenneExamenRegional: "Moyenne de l'Examen Régional",
    Moyenne1erAnneBac: "Moyenne 1ère année bac",
    Moyenne1erAnneBacFr: "Moyenne de la Première",
    MoyenneNationalBac: "Note de l'Examen National",
    MoyenneSem1Trim1Bac: "Moyenne Sem1/Trim1 Année du BAC",
    MoyenneCcAnneeBac: "Moyenne CC Année du BAC",
    ValiderInscription: "Créer mon compte",
    LabelCaseCocher:
      'J\'ai lu et j\'accepte les <a href="https://um6p.ma/fr/conditions-generales-dutilisation" target="_blank">conditions générales d\'utilisation</a>.',
    CreationCompte: "CRÉATION D'UN COMPTE CANDIDAT",
    Suivant: "Suivant",
    Precedent: "Précédent",
    Abcd: "Si votre note finale est basée sur un barème A/B/C/D ou équivalent, veuillez convertir vos notes en pourcentage et sélectionner « 100 » comme barème.*",
    PhraseCreationCompte:
      "Veuillez remplir le formulaire ci-dessous pour créer votre compte de candidat UM6P afin de postuler aux programmes.",
    TexteAvantCharte:
      "Conformément à la loi 09-08, vous disposez d'un droit d'accès, de rectification et d'opposition au traitement de vos données personnelles. Ce traitement a été autorisé par la CNDP sous le numéro A-1148/2023 relatif à la gestion de la scolarité.",
    DateFermeture: "Date fermeture : ",
    codeMassarNotMatch: "Code Massar non correspondant",
    TitreListeProgs: "Liste des programmes sélectionnés :",
    NoteListeProgrs:
      "Organisez votre liste : Glissez-déposez les éléments pour les trier selon votre préférence.",
    ChoixProg: "Choix",
    Math1BacTrimestre3: "Maths Année du Bac - Trim 3",
    Math1BacTrimestre3Autre: "Maths 2° Année Cycle Lycée Trim3",
    Maths2BacTrim3: "Maths 2ème Année Cycle Lycée - Trim 3",
    Maths2BacTrim3Autre: "Maths Année du Bac Trim3",
    Physique1BacTrim3: "Physique Année du Bac - Trim 3",
    Physique1BacTrim3Autre: "Physique 2° Année Cycle Lycée Trim3",
    Physique2BacTrim3: "Physique 2° Année Cycle Lycée - Trim3",
    Physique2BacTrim3Autre: "Physique Année du Bac Trim3",
    A1TrimSem1: "Année1 - S1/Trim1",
    A1NBDeRattrapageTrimSem1: "Année1 - S1/Trim1 Nb rattrapage",
    A1TrimSem2: "Année1 - S2/Trim2",
    A1NBDeRattrapageTrimSem2: "Année1 - S2/Trim2 Nb rattrapage",
    A2TrimSem1: "Année2 - S1/Trim1",
    A2NBDeRattrapageTrimSem1: "Année2 - S1/Trim1 Nb rattrapage",
    A2TrimSem2: "Année2 - S2/Trim2",
    A2NBDeRattrapageTrimSem2: "Année2 - S2/Trim2 Nb rattrapage",
    Trimestre3: "Année 1 - Trim 3",
    NBDeRattrapage13: "Année 1 - Trim 3 NB de rattrapage",
    Trimestre23: "Année 2 - Trim 3",
    NbrRattrapages23: "Année 2 - Trim 3 NB de rattrapage",
    ConfirmCodeEtudiant: "Ressaisir votre code Massar",
    ImprimerEtape: "Imprimer",
    MessageCondidaturesClotures: "Les candidatures sont clôturées",
    DejaInscrit:
      "Vous avez déjà un compte. Veuillez essayer de vous connecter via votre ",
    MotDePasseOublie:
      "Si vous avez oublié votre mot de passe, veuillez demander un changement de mot de passe depuis la page de connexion de votre ",
    LienCondidature: "portail candidat",
    Portail: "portail",
    Nationalite2: "Nationalité 2",
    StatutRefugie : "Êtes-vous en situation de réfugié ? ",
    DemandeBourseSociale : "Êtes-vous intéressé(e) par une bourse sociale ?",
    MajProgrammes: "Mettre à jour mes choix",
    SuccesMajProgrammes:
      "La mise à jour a été effectuée avec succès. Veuillez cliquer sur « Statut Candidature » pour consulter la liste des programmes sélectionnés.",
    Ici: "ici",
    SystemeNotationBac: "Système de Notation du BAC",
    SystemeNotationPostBac: "Système de Notation",
    MedecinePharmacie1:"Concours commun d’accès aux études de médecine et pharmacie :",
    MedecinePharmacie2:"En sélectionnant un des deux programmes, le deuxième est sélectionné par défaut.",
    ListeSpecialite:"Liste des spécialités du programme :",
    MerciSelectionner:"Merci de sélectionner entre ",
    MerciSelectionnerAuMoins:"Merci de sélectionner au moins ",
    MerciSelectionnerAuMaximum:"Merci de sélectionner au maximum ",
    Et:" et ",
    Specialites:" spécialités."
  },

  labelfr: {
    JustifRequis:"Un document justificatif sera requis pour la soumission de votre candidature.",
    ResultatSoumis:"Résultats du Bac soumis avec succès.",
    HintCodeMassar:"Veuillez saisir votre code Massar et non pas votre mot de passe Massar.",
    UneErreurEstSurvenue:
      "Une erreur est survenue lors de l'enregistrement de votre inscription",
    ProgrammeMinimum: "Veuillez sélectionner au moins un programme ou vérifiez le nombre de spécialités sélectionnées.",
    ChampsAnnexesObligatoires:"Merci de renseigner tous les champs/annexes obligatoires",
    ChampsObligatoires: "Merci de renseigner les champs obligatoires",
    AnnexesManquantes:
      "Merci d'ajouter toutes les annexes obligatoires ou non conforme.",
    ValiderNotes: "Valider les notes",
    ReadOnly: "La date de soumission de votre inscription est passée.",
    DateClotureInge:
      'Date de cloture du formulaire pour le cycle "ingénieur" : ',
    DateClotureMaster:
      'Date de cloture du formulaire pour le cycle "master" : ',
    DateClotureParallele:
      'Date de cloture du formulaire pour le cycle "parallèle" : ',
    DateCloturePostBacFr:
      'Date de cloture du formulaire pour le cycle "PostBac français" : ',
    DateCloturePostBacMa:
      'Date de cloture du formulaire pour le cycle "PostBac marocain" : ',
    DateCloturePostBacAu:
      'Date de cloture du formulaire pour le cycle "PostBac autre" : ',
    Introduction: "Création de compte",
    NomEtablissementMaster: "Nom d'établissement",
    SauverFormulaire: "Sauvegarder",
    MathsExpertNote: "Maths Expert Note",
    SoumettreCandidature: "Soumettre ma candidature",
    InformationsPersonnelles: "Informations personnelles",
    InformationsScolaire: "Informations académiques",
    MoyenneExamenRegional: "Moyenne de l'Examen Régional",
    InformationAnnexes: "Annexes",
    InformationResume: "Récapitulatif",
    ValiderInscription: "Créer mon compte",
    DiplomePostule: "Cycle souhaité",
    InfoTuteur: "Informations Tuteur",
    Programmes: "Sélection des programmes",
    InformationLicence: "Informations sur le Parcours Post-Bac",
    ObtentionBac: "Avez-vous terminé votre cursus?",
    NoteMasterEtProgIngenieur: "Notes et Nombre de rattrapages (la dernière année si disponible)",
    ExplicationNbDeRattrapage: "Nb de rattrapages = Nombre de rattrapages",
    Genre: "Genre",
    Nom: "Nom de famille",
    Prenom: "Prénom(s)",
    AddressTuteur: "Adresse tuteur",
    Email: "Email",
    ConfirmationEmail: "Ressaisir votre Email",
    TelPortable: "Téléphone",
    NumPassport: "Passeport",
    ConfirmationNumPassport: "Ressaisir Passeport",
    Pays: "Pays",
    PaysResidence: "Pays de résidence",
    EtesVousSportifHautNiveau: "Êtes-vous un sportif de haut niveau ?",
    Discipline: "Discipline",
    PaysEtablissement: "Pays d'établissement",
    CIN: "Carte d'identité nationale (CNIE) ",
    ConfirmationCIN: "Ressaisir Carte d'identité nationale (CNIE)",
    DateDeNaissance: "Date de naissance  (jj/mm/aaaa)",
    PaysNaissance: "Nationalité 1",
    EtrangerVivantAuMaroc: "Résident étranger au Maroc",
    EmployeEtatMarocain: "Employé de l'Etat marocain",
    SituationFamilial: "Situation familiale",
    Handicap: "Besoins spécifiques - Handicap",
    InformationPostal: "Coordonnées téléphoniques et postales:",
    SportifHautNiveau: "Sportif haut niveau",
    Addresse: "Adresse",
    Addresse2: "Adresse 2",
    Region: "Région",
    RegionAutre: "Précisez votre région",
    District: "Province",
    RelationCandidatTuteur: "Lien de parenté entre le candidat et le tuteur",
    SpecificationBaremBac: "Précisez votre barème",
    Ville: "Ville",
    CodePostal: "Code postal",
    Telephone: "Téléphone",
    Telephone1: "Téléphone 1",
    Telephone2: "Téléphone 2",
    InformationTuteur:
      "Veuillez nous fournir les coordonnées valides de votre tuteur légal:",
    Profession: "Profession",
    MemeAddressTuteur: "Utiliser l'adresse du candidat?",
    SelectionProgramme: "Sélection des programmes:",
    PreciserFiliereDuBac: "Preciser filiere du bac",
    InformationBac: "Informations sur le baccalauréat",
    TypeDeBac: "Type de baccalauréat",
    TypeDeBacAutre: "Précisez le type de bac",
    CodeEtudiant: "Code Massar",
    InformationBachelier: "Informations Bachelier:",
    VotreDiplomeActuel: "Votre diplôme actuel (en cours ou obtenu)",
    DiplomeTermine: "Êtes-vous déjà titulaire d'un diplôme de baccalauréat ?",
    PaysObtentionDiplome: "Pays d'obtention du diplôme",
    VilleObtenionDiplome: "Ville d'établissement",
    VilleEtablissement: "Ville du lycée",
    PaysLycee: "Pays du lycée",
    NomEtablissement: "Nom du lycée",
    VilleEtablissementAutre: "Précisez la ville du lycée si pas dans la liste",
    NomEtablissementAutre: "Précisez le nom du lycée si pas dans la liste",
    TypeEtablissement: "Public/Privé",
    TypeLicence: "Type Licence",
    Major: "Filière",
    DateEntree: "Date d'entrée",
    DateFin: "Date de fin (ou prévue)",
    EchelleNotation: "Votre barème de notation",
    EchelleNotationPrecision: "Veuillez préciser votre échelle de notation",
    DocumentsCandidat: "Documents Candidat:",
    DocumentBac: "Documents Bac:",
    PhotoCandidat: "Photo candidat",
    CarteIdentite: "Carte Identité (ou passeport)",
    DiplomeBac: "Diplome Bac",
    ReleveNoteBac: "Notes Lycée",
    DocumentSpecifique: "Documents spécifique",
    LettreMotivation: "Lettre motivation",
    CuriculumVitae: "Votre CV",
    LettreRecommendation1: "Lettre de recommandation 1",
    LettreRecommendation2: "Lettre de recommandation 2",
    CertificationHonneur: "Engagement sur l'honneur",
    CndpClause:
      "J'ai lu et j'accepte les conditions générales d'utilisation, notamment la mention relative à la protection des données personnelles.",
    ResidentEtrangeMaroc: "Résident étranger au Maroc",
    ConnaissanceFirsi: "Comment avez-vous eu connaissance de l'UM6P?",
    VilleNaissance: "Ville de naissance",
    PrecisionVilleNaissance: "Précisez votre ville de naissance",
    LabelCaseCocher:
      'J\'ai lu et j\'accepte les <a href="https://um6p.ma/fr/conditions-generales-dutilisation" target="_blank">conditions générales d\'utilisation</a>.',
    ChoixDiplome: "Cycle souhaité",
    ChoixCycle: "Choix du cycle",
    LienCharte:
      '<a href="https://um6p.ma/fr/conditions-generales-dutilisation" target="_blank">Cliquez ici pour consulter la charte</a>',
    NatureHandicap: "Veuillez préciser votre handicap",
    TelechargerDocument: "Téléchargement de documents",
    DiplomeActuel: "Votre cursus actuel",
    FiliereDuBac: "Domaine du baccalauréat",
    MoyGen2eCycleLycee: "Moyenne 2e année cycle lycée",
    AnneeObtentionBac: "Année d'obtention du bac",
    MoyGenAnnuelleBac: "Baccalaureate average grade",
    NoteExamenNational: "Note de l'examen national",
    NoteMathPhysique:
      "Veuillez saisir vos notes de mathématiques et de physique",
    NoteMathPhysiqueNational:
      "Please enter Maths & Physics grades: > Physics > National exam grade",
    NoteFinalDiplome: "Note final du diplôme",
    Spécialite1: "Spécialité 1",
    Specialite2: "Spécialité 2",
    MathsExpertOption: "Option Maths Expert",
    Specialite1note: "Spécialité 1 Note",
    Specialite2note: "Spécialité 2 Note",
    MoyenneGenDiplome: "Degree average grade",
    BaremeNote: "Votre barème de notation au Bac",
    NbrRattrapages1: "Nb rattrapage s1",
    NbrRattrapages2: "Nb rattrapage s2",
    NbrRattrapages3: "Nb rattrapage s3",
    NbrRattrapages4: "Nb rattrapage s4",
    NbrRattrapages5: "Nb rattrapage s5",
    NbrRattrapages6: "Nb rattrapage s6",
    NbrRattrapages7: "Nb rattrapage s7",
    NbrRattrapages8: "Nb rattrapage s8",
    NbrRattrapages9: "Nb rattrapage s9",
    NbrRattrapages10: "Nb rattrapage s10",
    NbrRattrapages11: "Nb rattrapage s11",
    NbrRattrapages12: "Nb rattrapage s12",
    Semestre1: "Semestre 1",
    Semestre2: "Semestre 2",
    Semestre3: "Semestre 3",
    Semestre4: "Semestre 4",
    Semestre5: "Semestre 5",
    Semestre6: "Semestre 6",
    Semestre7: "Semestre 7",
    Semestre8: "Semestre 8",
    Semestre9: "Semestre 9",
    Semestre10: "Semestre 10",
    Semestre11: "Semestre 11",
    Semestre12: "Semestre 12",
    Sujet1Bac: "Sujet 1",
    Sujet2Bac: "Sujet 2",
    Math1BacSem1: "Maths Année du Bac - Sem 1/Trim 1",
    Math1BacSem1Autre: "Maths 2° Année Cycle Lycée Sem1/Trim1",
    Math1BacSem2: "Maths Année du Bac - Sem 2/Trim 2",
    Math1BacSem2Autre: "Maths 2° Année Cycle Lycée Sem2/Trim2",
    Math2BacSem1: "Maths 2ème Année Cycle Lycée - Sem 1/Trim 1",
    Math2BacSem1Autre: "Maths Année du Bac Sem1/Trim1",
    Math2BacSem2: "Maths 2e Bac-Sem 2",
    Math2BacSem2Autre: "Maths Année du Bac Sem2/Trim2",
    MathNational: "Maths National",
    Physique1BacSem1: "Physique Année du Bac - Sem 1/Trim 1",
    Physique1BacSem1Autre: "Physique 2° Année Cycle Lycée Sem1/Trim1",
    Physique1BacSem2: "Physique 1er Bac-Sem 2",
    Physique1BacSem2Autre: "Physique 2° Année Cycle Lycée Sem2/Trim2",
    Physique2BacSem1: "Physique 2e Bac-Sem 1",
    Physique2BacSem1Autre: "Physique Année du Bac Sem1/Trim1",
    Physique2BacSem2: "Physique 2e Bac-Sem 2",
    Physique2BacSem2Autre: "Physique Année du Bac - Sem 2/Trim 2",
    PhysiqueNational: "Physique National",
    DateEntreeLicence: "Date entrée",
    Suivant: "Suivant",
    Precedent: "Précédent",
    Moyenne1erAnneBac: "Moyenne 1ère année bac",
    Moyenne1erAnneBacFr: "Moyenne de la Première",
    MoyenneNationalBac: "Note de l'Examen National",
    MoyenneSem1Trim1Bac: "Moyenne Sem1/Trim1 Année du BAC",
    MoyenneCcAnneeBac: "Moyenne CC Année du BAC",
    CreationCompte: "CRÉATION D'UN COMPTE CANDIDAT",
    InfoPerso: "Informations personnelles",
    Abcd: "Si votre note finale est basée sur un barème A/B/C/D ou équivalent, veuillez convertir vos notes en pourcentage et sélectionner « 100 » comme barème.*",
    PhraseCreationCompte:
      "Veuillez remplir le formulaire ci-dessous pour créer votre compte de candidat UM6P afin de postuler aux programmes.",
    TexteAvantCharte:
      "Conformément à la loi 09-08, vous disposez d'un droit d'accès, de rectification et d'opposition au traitement de vos données personnelles. Ce traitement a été autorisé par la CNDP sous le numéro A-1148/2023 relatif à la gestion de la scolarité.",
    DateFermeture: "Date fermeture : ",
    codeMassarNotMatch: "Code Massar non correspondant",
    TitreListeProgs: "Liste des programmes sélectionnés :",
    NoteListeProgrs:
      "Organisez votre liste : Glissez-déposez les éléments pour les trier selon votre préférence.",
    ChoixProg: "Choix",
    Math1BacTrimestre3: "Maths Année du Bac - Trim 3",
    Math1BacTrimestre3Autre: "Maths 2° Année Cycle Lycée Trim3",
    Maths2BacTrim3: "Maths 2ème Année Cycle Lycée - Trim 3",
    Maths2BacTrim3Autre: "Maths Année du Bac Trim3",
    Physique1BacTrim3: "Physique Année du Bac - Trim 3",
    Physique1BacTrim3Autre: "Physique 2° Année Cycle Lycée Trim3",
    Physique2BacTrim3: "Physique 2ème Année Cycle Lycée - Trim",
    Physique2BacTrim3Autre: "Physique Année du Bac Trim3",
    A1TrimSem1: "Année 1 - S1/Trim1",
    A1NBDeRattrapageTrimSem1: "Année 1 - S1/Trim1 NB de rattrapage",
    A1TrimSem2: "Année 1 - S2/Trim2",
    A1NBDeRattrapageTrimSem2: "Année 1 - S2/Trim2 NB de rattrapage",
    A2TrimSem1: "Année 2 - S1/Trim1",
    A2NBDeRattrapageTrimSem1: "Année 2 - S1/Trim1 NB de rattrapage",
    A2TrimSem2: "Année 2 - S2/Trim2",
    A2NBDeRattrapageTrimSem2: "Année 2 - S2/Trim2 NB de rattrapage",
    Trimestre3: "Année 1 - Trim 3",
    NBDeRattrapage13: "Année 1 - Trim 3 NB de rattrapage",
    Trimestre23: "Année 2 - Trim 3",
    NbrRattrapages23: "Année 2 - Trim 3 NB de rattrapage",
    ConfirmCodeEtudiant: "Ressaisir votre code Massar",
    ImprimerEtape: "Imprimer",
    MessageCondidaturesClotures: "Les candidatures sont clôturées",
    DejaInscrit:
      "Vous avez déjà un compte. Veuillez essayer de vous connecter via votre ",
    MotDePasseOublie:
      "Si vous avez oublié votre mot de passe, veuillez demander un changement de mot de passe depuis la page de connexion de votre ",
    LienCondidature: "portail candidat",
    Portail: "portail",
    Nationalite2: "Nationalité 2",
    StatutRefugie : "Êtes-vous en situation de réfugié ? ",
    DemandeBourseSociale : "Êtes-vous intéressé(e) par une bourse sociale ?",
    MajProgrammes: "Mettre à jour mes choix",
    SuccesMajProgrammes:
      "La mise à jour a été effectuée avec succès. Veuillez cliquer sur « Statut Candidature » pour consulter la liste des programmes sélectionnés.",
    Ici: "ici",
    SystemeNotationBac: "Système de Notation du BAC",
    SystemeNotationPostBac: "Système de Notation",
    MedecinePharmacie1:"Concours commun d’accès aux études de médecine et pharmacie :",
    MedecinePharmacie2:"En sélectionnant un des deux programmes, le deuxième est sélectionné par défaut.",
    ListeSpecialite:"Liste des spécialités du programme :",
    MerciSelectionner:"Merci de sélectionner entre ",
    MerciSelectionnerAuMoins:"Merci de sélectionner au moins ",
    MerciSelectionnerAuMaximum:"Merci de sélectionner au maximum ",
    Et:" et ",
    Specialites:" spécialités."
  },

  labelen: {
    JustifRequis:"Supporting documentation will be required for your application.",
    ResultatSoumis:"Bac results successfully submitted.",
    HintCodeMassar:"Please enter your Massar code and not your Massar password.",
    UneErreurEstSurvenue: "An error has occurred during registration",
    ProgrammeMinimum: "Please select at least one programme or check the number of specialisations selected.",
    ChampsAnnexesObligatoires:"Please complete all mandatory fields/attachments",
    ChampsObligatoires: "Please fill in the required fields",
    AnnexesManquantes: "Please add any mandatory or non-compliant attachments.",
    ValiderNotes: "Validate grades",
    ReadOnly: "The deadline for submitting your registration has passed.",
    DateClotureInge: 'Closing date of the form for the "engineer" cycle : ',
    DateClotureMaster: 'Closing date of the form for the "master" cycle : ',
    DateClotureParallele:
      'Closing date of the form for the "parallele" cycle : ',
    DateCloturePostBacFr:
      'Closing date of the form for the "french PostBac" cycle : ',
    DateCloturePostBacMa:
      'Closing date of the form for the "maroccan PostBac" cycle : ',
    DateCloturePostBacAu:
      'Closing date of the form for the "other PostBac" cycle : ',
    Introduction: "Account Creation",
    SauverFormulaire: "Save",
    MathsExpertNote: "Maths Expert Grade",
    SoumettreCandidature: "Submit",
    InformationsPersonnelles: "Personal Information",
    InformationAnnexes: "Documents Upload",
    InformationResume: "Summary",
    InformationsScolaire: "Academic Information",
    DiplomePostule: "Please select your cycle.",
    InfoTuteur: "Tutor information",
    InfoPerso: "Personal Information",
    Programmes: "Programs Selection",
    ObtentionBac: "Have you completed your studies?",
    NoteMasterEtProgIngenieur: "Grades and Number of Retakes (and last year if possible)",
    ExplicationNbDeRattrapage: 'Number of retakes = Number of attempts to retake the exam',
    Genre: "Gender",
    Nom: "Last Name",
    ValiderInscription: "Create my account",
    Prenom: "First Name(s)",
    MoyenneExamenRegional: "Regional Exam Grade",
    Moyenne1erAnneBac: "First Year Grade",
    MoyenneNationalBac: "National Exam Grade",
    NoteFinalDiplome: "Degree average grade",
    SpecificationBaremBac: "Specify your grading scale",
    InformationLicence: "Post-Bac Degree Information",
    PaysEtablissement: "Establishment Country",
    Email: "Email",
    ConfirmationEmail: "Re-enter your Email",
    NomEtablissementMaster: "Establishment Name",
    Suivant: "Next",
    Precedent: "Previous",
    AddressTuteur: "Tutor Address",
    TelPortable: "Phone",
    NumPassport: "Passport",
    ConfirmationNumPassport: "Re-enter Passeport",
    Pays: "Country",
    PaysResidence: "Country of Residence",
    EtesVousSportifHautNiveau: "Are you a high-level athlete?",
    Discipline: "Discipline",
    CIN: "National ID card, CNIE",
    ConfirmationCIN: "Re-enter National ID card, CNIE",
    DateDeNaissance: "Date of Birth (dd/mm/yyyy)",
    PaysNaissance: "Nationality 1",
    EmployeEtatMarocain: "Moroccan state employee",
    SituationFamilial: "Family situation",
    Handicap: "Specific needs - Handicap",
    InformationPostal: "Telephone and address details:",
    SportifHautNiveau: "High-level athlete",
    Addresse: "Address",
    Addresse2: "Address 2",
    Region: "Region",
    RegionAutre: "Specify your region",
    District: "Province",
    Ville: "City",
    PreciserFiliereDuBac: "Preciser filiere du bac",
    CodePostal: "Zip Code",
    Telephone: "Phone",
    Telephone1: "Phone 1",
    Telephone2: "Phone 2",
    InformationTuteur:
      "Please provide us with a valid contact information of your legal tutor:",
    Profession: "Profession",
    RelationCandidatTuteur: "Applicant/Tutor Relationship",
    MemeAddressTuteur: "Use the same applicant address?",
    SelectionProgramme: "Programs Selection:",
    TypeDeBac: "Type of Baccalaureate",
    TypeDeBacAutre: "Specify the type of high school diploma",
    CodeEtudiant: "Massar Code",
    InformationBac: "Baccalaureate Information",
    InformationBachelier: "Baccalaureate Information:",
    VotreDiplomeActuel: "Your current degree (in progress or obtained) ",
    DiplomeTermine: "Have you completed your Degree?",
    PaysObtentionDiplome: "Country of Graduation",
    VilleObtenionDiplome: "Establishment City",
    NomEtablissement: "High School Name",
    VilleEtablissementAutre: "Specify High School City if not in the list",
    NomEtablissementAutre: "Specify High School Name if not in the list",
    TypeEtablissement: "Public/Private",
    TypeLicence: "Type Licence",
    VilleEtablissement: "High School City",
    PaysLycee: "High School Country",
    DiplomeActuel: "Your current studies",
    Major: "Major",
    DateEntree: "Entry date",
    DateFin: "End date (or expected)",
    EchelleNotation: "Your Grading scale",
    EchelleNotationPrecision: "Please specify your rating scale",
    DocumentsCandidat: "Candidate Documents:",
    DocumentBac: "Baccalaureate Documents:",
    PhotoCandidat: "Candidate Picture",
    CarteIdentite: "National ID card (CIN or Passport)",
    DiplomeBac: "Baccalaureate Degree",
    ReleveNoteBac: "Baccalaureate Transcript",
    DocumentSpecifique: "Specific Documents:",
    LettreMotivation: "Motivation Letter",
    CuriculumVitae: "Your Resume/CV",
    LettreRecommendation1: "Recommendation Letter 1",
    LettreRecommendation2: "Recommendation Letter 2",
    ValidationForm: "Submit",
    CertificationHonneur: "Honor pledge",
    CndpClause:
      "I have read and accept the conditions of use, in particular the statement concerning the protection of personal data.",
    ResidentEtrangeMaroc: "Foreign resident in Morocco",
    ConnaissanceFirsi: "How did you learn about the UMP6?",
    VilleNaissance: "City of Birth",
    PrecisionVilleNaissance: "Please specify your city of birth",
    ChoixDiplome: "Please select the level of studies you are interested in",
    ChoixCycle: "Level of studies",
    LienCharte:
      '<a href="In accordance with law 09-08, you have the right to access, rectify and oppose the processing of your personal data. This processing has been authorized by the CNDP : https://um6p.ma/fr/conditions-generales-dutilisation" target="_blank">CNDP Clause: </a>',
    TelechargerDocument: "4. Upload documents",
    NatureHandicap: "please specify your disability",
    FiliereDuBac: "Baccalaureate Field",
    MoyGen2eCycleLycee: "Transcript 2nd year of high school",
    AnneeObtentionBac: "Graduation Year",
    MoyGenAnnuelleBac: "Baccalaureate annual average grade",
    MoyenneSem1Trim1Bac: "Average Sem1/Trim1 Year of Bac",
    MoyenneCcAnneeBac: "Average CC Year of BAC",
    NoteExamenNational: "Baccalaureate national exam grade",
    NoteMathPhysique: "Please enter Maths & Physics grades:",
    NoteMathPhysiqueNational:
      "Please enter Maths & Physics grades: > Physics > National exam grade",
    Spécialite1: "Specialty 1",
    Specialite2: "Specialty 2",
    MathsExpertOption: "Option Maths Expert",
    Specialite1note: "Specialty 1 Grade",
    Specialite2note: "Specialty 2 Grade",
    MoyenneGenDiplome: "Degree average grade",
    BaremeNote: "Your Bac Grading scale",
    LabelCaseCocher:
      'I have read and accept the <a href="https://um6p.ma/en/terms-and-conditions-use" target="_blank">terms and conditions</a>.',
    NbrRattrapages1: "Nb of Makeup s1",
    NbrRattrapages2: "Nb of Makeup s2",
    NbrRattrapages3: "Nb of Makeup s3",
    NbrRattrapages4: "Nb of Makeup s4",
    NbrRattrapages5: "Nb of Makeup s5",
    NbrRattrapages6: "Nb of Makeup s6",
    NbrRattrapages7: "Nb of Makeup s7",
    NbrRattrapages8: "Nb of Makeup s8",
    NbrRattrapages9: "Nv of Makeup s9",
    NbrRattrapages10: "Nb of Makeup s10",
    NbrRattrapages11: "Nb of Makeup s11",
    NbrRattrapages12: "Nb of Makeup s12",
    Semestre1: "Semester 1",
    Semestre2: "Semester 2",
    Semestre3: "Semester 3",
    Semestre4: "Semester 4",
    Semestre5: "Semester 5",
    Semestre6: "Semester 6",
    Semestre7: "Semester 7",
    Semestre8: "Semester 8",
    Semestre9: "Semester 9",
    Semestre10: "Semester 10",
    Semestre11: "Semester 11",
    Semestre12: "Semester 12",
    Sujet1Bac: "Subject 1",
    Sujet2Bac: "Subject 2",
    Math1BacSem1: "Maths Année du Bac - Sem 1/Trim 1",
    Math1BacSem1Autre: "Maths 2° Année Cycle Lycée Sem1/Trim1",
    Math1BacSem2: "Maths Année du Bac - Sem 2/Trim 2",
    Math1BacSem2Autre: "Maths 2° Année Cycle Lycée Sem2/Trim2",
    Math2BacSem1: "Maths 2ème Année Cycle Lycée - Sem 1/Trim 1",
    Math2BacSem1Autre: "Maths année du bac - Sem 1",
    Math2BacSem2: "Maths 2e Bac-Sem 2",
    Math2BacSem2Autre: "Maths année du bac - Sem 2",
    MathNational: "Maths National",
    Physique1BacSem1: "Physique Année du Bac - Sem 1/Trim 1",
    Physique1BacSem1Autre: "Physique 2° Année Cycle Lycée Sem1/Trim1",
    Physique1BacSem2: "Physique 1er Bac-Sem 2",
    Physique1BacSem2Autre: "Physique 2° Année Cycle Lycée Sem2/Trim2",
    Physique2BacSem1: "Physique 2e Bac-Sem 1",
    Physique2BacSem1Autre: "Physique Année du Bac Sem1/Trim1",
    Physique2BacSem2: "Physique 2e Bac-Sem 2",
    Physique2BacSem2Autre: "Physique Année du Bac - Sem 2/Trim 2",
    PhysiqueNational: "Physique National",
    DateEntreeLicence: "Date entry",
    CreationCompte: "CANDIDATE ACCOUNT CREATION",
    Abcd: "If your grading scale is based on A/B/C/D, please convert your grades in percentage & use “100” as you grading scale.*",
    PhraseCreationCompte:
      "Please fill out the form below to create your UM6P account to apply for UM6P programs.",
    TexteAvantCharte:
      "In accordance with law 09-08, you have the right to access, rectify and object to the processing of your personal data. This processing has been authorised by the CNDP under number A-1148/2023 relating to school management.",
    DateFermeture: "Closing date : ",
    codeMassarNotMatch: "Massar Code not match",
    TitreListeProgs: "Selected programs :",
    NoteListeProgrs:
      "Organize your list: Drag and drop items to sort them according to your preference.",
    ChoixProg: "Choice",
    Math1BacTrimestre3: "Maths Année du Bac - Trim 3",
    Math1BacTrimestre3Autre: "Maths 2° Année Cycle Lycée Trim3",
    Maths2BacTrim3: "Maths 2ème Année Cycle Lycée - Trim 3",
    Maths2BacTrim3Autre: "Maths Année du Bac Trim3",
    Physique1BacTrim3: "Physique Année du Bac - Trim 3",
    Physique1BacTrim3Autre: "Physique 2° Année Cycle Lycée Trim3",
    Physique2BacTrim3: "Physique 2ème Année Cycle Lycée - Trim",
    Physique2BacTrim3Autre: "Physique Année du Bac Trim3",
    A1TrimSem1: "Année 1 - S1/Trim1",
    A1NBDeRattrapageTrimSem1: "Année 1 - S1/Trim1 NB de rattrapage",
    A1TrimSem2: "Année 1 - S2/Trim2",
    A1NBDeRattrapageTrimSem2: "Année 1 - S2/Trim2 NB de rattrapage",
    A2TrimSem1: "Année 2 - Sem1/Trim1",
    A2NBDeRattrapageTrimSem1: "Année 2 - S1/Trim1 NB de rattrapage",
    A2TrimSem2: "Année 2 - S2/Trim2",
    A2NBDeRattrapageTrimSem2: "Année 2 - S2/Trim2 NB de rattrapage",
    Trimestre3: "Année 1 - Trim 3",
    NBDeRattrapage13: "Année 1 - Trim 3 NB de rattrapage",
    Trimestre23: "Année 2 - Trim 3",
    NbrRattrapages23: "Année 2 - Trim 3 NB de rattrapage",
    ConfirmCodeEtudiant: "Re-enter your Massar code",
    ImprimerEtape: "Print",
    MessageCondidaturesClotures: "Programs are closed",
    DejaInscrit: "You already have an account. Please try to login via your ",
    MotDePasseOublie:
      "If you have forgotten your password, please request a password change from the login page on your ",
    LienCondidature: "candidate portal link",
    Portail: "portal",
    Nationalite2: "Nationality 2",
    StatutRefugie : "Are you a refugee? ",
    DemandeBourseSociale : "Are you interested in a social scholarship?",
    MajProgrammes: "Update my choices",
    SuccesMajProgrammes:
      "The update was completed successfully. Please click on “Application Status” to view the list of selected programs.",
    Ici: "here",
    SystemeNotationBac: "Grading system of Baccalaureate (BAC)",
    SystemeNotationPostBac: "Grading system",
    MedecinePharmacie1:"Joint entrance examination for medical and pharmacy studies :",
    MedecinePharmacie2:"when selecting one of the two programmes, the second one is selected by default.",
    ListeSpecialite:"List of programme specialisations :",
    MerciSelectionner:"Please select between ",
    MerciSelectionnerAuMoins:"Please select at least ",
    MerciSelectionnerAuMaximum:"Please select a maximum of ",
    Et:" and ",
    Specialites:" specialities."
  },
  ShowBtnMajProgrammes:false,
  Token: null,
  Loader: false,
  ChoixCycle: [],
  NiveauEtude: [],
  NiveauEtudeFixe: [],
  NiveauEtudeFixeSoumission: [],
  Ouvert: false,
  MasterSoumission: "",
  ParalleleSoumission: "",
  ParalleleBacSoumission: "",
  IngenieurSoumission: "",
  PostBacFrSoumission: "",
  PostBacMaSoumission: "",
  PostBacAuSoumission: "",
  InscriptionFermee: false,
  inscription: {
    UtmCampaign: null,
    UtmContent: null,
    UtmMedium: null,
    UtmTerm: null,
    UtmSource: null,
    ReadOnly: false,
    ReadOnlyProgrammes: false,
    ChoixCycle: null,
    EncryptId: null,
    Contact: null,
    ProvinceMA: null,
    Archive: null,
    AnneeScolaire: null,
    Etat: null,
    Email: null,
    ConfirmationEmail: null,
    Nom: null,
    ConnaissanceUm6p: null,
    Prenom: null,
    Genre: null,
    DateDeNaissance: null,
    DateDeNaissanceFormatee: null,
    PaysDeResidence: null,
    SportifHautNiveau: null,
    Disciplines: [],
    PaysDeNaissance: null,
    Tel: null,
    AutreAdresse: null,
    AutrePays: null,
    SituationDeHandicap: null,
    TypeDHandicap: [],
    DisiciplineSportive: null,
    AdresseAuMaroc: null,
    Adresse2: null,
    Pays: null,
    DemandeBourseSociale:null,
    StatutRefugie : null,
    RegionMA: null,
    VilleMaroc: null,
    CodePostal: null,
    AutreAdresse2: null,
    NumCniPasseport: null,
    ConfirmationNumCniPasseport: null,
    AutreVille: null,
    AutreCodePostal: null,
    EtrangerResidantAuMaroc: null,
    VilleNaissance: null,
    PrecisionVilleNaissance: null,
    EmployeEtatMarocain: null,
    SituationFamiliale: null,
    NumDossier: null,
    NiveauDEtude: [],
    RGPD: null,
    Tel2: null,
    InfosBac: {
      IdCrypte: null,
      CodeMassarCodeNationalEtudiant: null,
      ConfirmCodeMassarCodeNationalEtudiant: null,
      TypeDeBac: null,
      AvezVousObtenuVotreDiplome: null,
      NoteBacRegional: null,
      AutreVilleLycee: null,
      Math1erBacSemestre1: null,
      Math1erBacSemestre2: null,
      Maths1ErBacTrim3: null,
      Math2erBacSemestre1: null,
      Math2erBacSemestre2: null,
      Physique1ErBacTrim3: null,
      Physique2EmeBacTrim3: null,
      Maths2EmeBacTrim3: null,
      Lycee: null,
      MoyGen2EmeAnneeCycleLycee: null,
      TypeDEtablissement: null,
      PaysDuLycee: null,
      AnneeDObtentionDuBaccalaureatOuEspere: null,
      MoyGenDuBac: null,
      DomaineDuBaccalaureat: null,
      NoteDuBacNational: null,
      VilleDuLycee: null,
      NomDuLycee: null,
      BaremeDeNotationAuBac: null,
      SpecificationDuBaremeDeBac: null,
      Specialite1: null,
      Specialite2: null,
      MathsExpertOption: null,
      NoteSpecialite1: null,
      NoteSpecialite2: null,
      NoteMathsExpertOption: null,
      MathsNational: null,
      Physique1erBacSemestre1: null,
      Physique1erBacSemestre2: null,
      Physique2erBacSemestre1: null,
      Physique2erBacSemestre2: null,
      PhysiqueNational: null,
      PrecisezTypeDiplome: null,
      TypeBacAutre: null,
      Moy1erAnneeBac: null,
      Pp: null,
      InscriptionUM6P: null,
      SystemeNotationBac: null,
    },
    InfosMaster: {
      IdCrypte: null,
      VotreDiplomeActuelEnCoursOuObtenu: null,
      AvezVousObtenuVotreDiplome: null,
      PaysObtentionDuDiplome: null,
      VilleObtentionDuDiplome: null,
      NomEtablissement: null,
      PublicPrive: null,
      Majeure: null,
      DateEntree: null,
      DateDeFinOuEspere: null,
      NoteFinaleDuDiplome: null,
      VotreEchelleDeNotation: null,
      VeuillezPreciserVotreEchelleDeNotation: null,
      Sem1NoteFinale: null,
      Sem1NbDeRattrapage: null,
      Sem2NoteFinale: null,
      Sem2NbDeRattrapage: null,
      Sem3NoteFinale: null,
      Sem3NbDeRattrapage: null,
      Sem4NoteFinale: null,
      Sem4NbDeRattrapage: null,
      Sem5NoteFinale: null,
      Sem5NbDeRattrapage: null,
      Sem6NoteFinale: null,
      Sem6NbDeRattrapage: null,
      Sem7NoteFinale: null,
      Sem7NbDeRattrapage: null,
      Sem8NoteFinale: null,
      Sem8NbDeRattrapage: null,
      Sem9NoteFinale: null,
      Sem9NbDeRattrapage: null,
      Sem10NoteFinale: null,
      Sem10NbDeRattrapage: null,
      Sem11NoteFinale: null,
      Sem11NbDeRattrapage: null,
      Sem12NoteFinale: null,
      Sem12NbDeRattrapage: null,
      Annee1TRIM3: null,
      Annee1Trim3NBDeRattrapage: null,
      Annee2Trim3: null,
      Annee2Trim3NBDeRattrapage: null,
      Etablissement: null,
      Pp: null,
      InscriptionUM6P: null,
      SystemeNotationPostBac: null,
    },
    InfosTuteur: {
      IdCrypte: null,
      Genre: null,
      Prenom: null,
      Nom: null,
      Profession: null,
      NatureDeLaRelation: null,
      Tel: null,
      Email: null,
      MemeAdresseQueLeCandidat: null,
      Adresse1: null,
      Adresse2: null,
      Pays: null,
      Region: null,
      Ville: null,
      CodePostal: null,
      ProvinceMaroc: null,
      InscriptionUM6P: null,
    },
    ListeVueProgrammes: [],
    ListeProgrammesUm6p: [],
  },

  validIntroduction: null,
  validInfoScolaire: false,
  validProg: null,
  validInfoPerso: null,
  NoteBacMaxAutorise: null,
  NoteBacMaxAutoriseMaster: null,
  lectureSeule: null,
  lectureSeuleBarem: null,
  rules: {
    alphaNumerique: [
      (v) => !!v || "Champ obligatoire",
      (v) => /^[a-zA-Z0-9]+$/.test(v) || "Format incorrect",
    ],
    Verifier: {
      Equal(s1, s2, lang) {
        if (s1 && s2) {
          if (s1.toLowerCase() !== s2.toLowerCase()) {
            return lang == "lang00"
              ? "Code Massar non correspondant"
              : "Massar Code not match";
          }
        }

        if (!s2) {
          return lang == "lang00" ? "Champ obligatoire" : "Mandatory field";
        }

        return true;
      },
    },
    emailObligatoire: [
      (v) => !!v || "Champ obligatoire",
      (v) => /.+@.+\..+/.test(v) || "Format email incorrect",
    ],

    email: [(v) => !v || /.+@.+\..+/.test(v) || "Format email incorrect"],

    cni: [
      (v) => !!v || "Champ obligatoire",
      (v) =>
        /^[a-zA-Z0-9_.-]*$/.test(v) ||
        "Caractères autorisés : a-z A-Z 0-9 _ - . ",
    ],
    checkboxObligatoire: [(v) => v === true || "Vous devez cocher cette case"],

    obligatoire: [(v) => !!v || "Champ obligatoire"],
    arrayObligatoire: [(v) => (v && v.length > 0) || "Champ obligatoire"],

    obligatoireWithZero: [
      (v) =>
        (v !== null && v !== undefined && v !== "") ||
        v === 0 ||
        "Champ obligatoire",
    ],

    telephone: [
      (v) => !!v || "Champ obligatoire",
      (v) =>
        /^(\+\d{1,4}\s?)?(\d{1,}[\s.-]?){8,}$/.test(v) ||
        "Format de téléphone incorrect",
    ],

    requiredField(primaryField, otherField) {
      // Si le champ principal est vide et le champ supplémentaire est vide, retournez une erreur
      if (!primaryField && !otherField) {
        return "Ce champ est obligatoire";
      }

      // Sinon, la validation est réussie
      return true;
    },
  },

  ProgrammesListe: [],
  ValiderNotes() {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: this.Token,
        },
      })
      .post("um6p/ValiderNotes/", this.inscription);
  },

  InscriptionExtranet(Candidat) {
    return Api.post("extranet/Inscription", Candidat);
  },

  async GetInscriptionExistante(token) {
    try {
      const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("um6p/GetInscription");

      if(reponse && reponse.status === 200){
        return reponse.data;
      }
      else {
        return "error"
      }
    } catch (error) {
      console.log(error);
      return "error";
    }
  },
  async GetParamInscription(fileid) {
    try {
      const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
        },
      })
      .get("um6p/GetParamInscription/"+fileid);

      if(reponse && reponse.status === 200){
        return reponse.data;
      }
      else{
        return "error";
      }
    } catch (error) {
      console.log(error);
      return "error";
    }
  },
  GetNiveauDiplome(storeCatalogue) {
    storeCatalogue.FiliereIng = [];
    if (this.inscription.NiveauDEtude.indexOf(storeCatalogue.DataId.ProgrammeIngenieur) >= 0
     || this.inscription.NiveauDEtude.indexOf(storeCatalogue.DataId.ProgrammeParallele) >= 0
    ) {
      storeCatalogue.FiliereIng = storeCatalogue.DiplomeActuel.filter(
        (obj) => obj.code === "INGE" || obj.code === "2"
      );
    }
    if(this.inscription.NiveauDEtude.indexOf(storeCatalogue.DataId.ProgrammeParalleleBac1) >= 0 ){
      storeCatalogue.FiliereIng = storeCatalogue.FiliereIng.concat(storeCatalogue.DiplomeActuel.filter(
        (obj) => obj.code === "1" || obj.id === storeCatalogue.DataId.BacPlus2
      ));
    }
    // On ne garde que les cursrus de bac +3 à bac+6.
    if(this.inscription.NiveauDEtude.indexOf(storeCatalogue.DataId.Master) >= 0 ){
      storeCatalogue.FiliereIng = storeCatalogue.FiliereIng.concat(storeCatalogue.DiplomeActuel.filter(
        (obj) => obj.code !== "INGE" && (obj.code === "" || obj.code === "2")
      ));
    }

    storeCatalogue.FiliereIng = storeCatalogue.FiliereIng.sort((a, b) => {
          return a.lang00.localeCompare(b.lang00);
        });
  },

  async InscriptionUm6p(submit) {
    try {
      const reponse = await axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          valide: submit,
        },
      })
      .post("um6p/Inscription", this.inscription);

      if(reponse){
        return reponse;
      }
    } catch (error) {
      console.log(error);
      return "error";
    }
    
  },

  ConvertDateApiToDateVue(dateApi) {
    if (dateApi) {
      return moment(dateApi, "YYYY-MM-DD[T]hh:mm:ss").format("YYYY-MM-DD");
    } else {
      return null;
    }
  },

  //Mapper l'inscription Existante
  MapperInscriptionExistante(response) {
    this.inscription = {
      ReadOnly: response.readOnly,
      ReadOnlyProgrammes: response.readOnlyProgrammes,
      ChoixCycle: response.choixCycle,
      EncryptId: response.encryptId,
      Contact: response.contact,
      ProvinceMA: response.provinceMA,
      Archive: response.archive,
      AnneeScolaire: response.anneeScolaire,
      Etat: response.etat,
      Email: response.email,
      ConfirmationEmail: response.email,
      Nom: response.nom,
      ConnaissanceUm6p: response.connaissanceUm6p,
      Prenom: response.prenom,
      Genre: response.genre,
      DateDeNaissance: this.ConvertDateApiToDateVue(response.dateDeNaissance),
      PaysDeResidence: response.paysDeResidence,
      SportifHautNiveau: response.sportifHautNiveau,
      PaysDeNaissance: response.paysDeNaissance,
      Nationalite2: response.nationalite2,
      DemandeBourseSociale : response.demandeBourseSociale,
      StatutRefugie : response.statutRefugie,
      Tel: response.tel,
      AutreAdresse: response.autreAdresse,
      AutrePays: response.autrePays,
      SituationDeHandicap: response.situationDeHandicap,
      AdresseAuMaroc: response.adresseAuMaroc,
      Adresse2: response.adresse2,
      Pays: response.pays,
      RegionMA: response.regionMA,
      VilleMaroc: response.villeMaroc,
      CodePostal: response.codePostal,
      AutreAdresse2: response.autreAdresse2,
      NumCniPasseport: response.numCniPasseport,
      ConfirmationNumCniPasseport: response.numCniPasseport,
      AutreVille: response.autreVille,
      AutreCodePostal: response.autreCodePostal,
      EtrangerResidantAuMaroc: response.etrangerResidantAuMaroc,
      VilleNaissance: response.villeNaissance,
      PrecisionVilleNaissance: response.precisionVilleNaissance,
      EmployeEtatMarocain: response.employeEtatMarocain,
      SituationFamiliale: response.situationFamiliale,
      NumDossier: response.numDossier,
      NiveauDEtude: response.niveauDEtude,
      RGPD: response.rgpd,
      Tel2: response.tel2,
      TypeDHandicap: [],
      Disciplines: [],
      InfosBac: {
        CodeMassarResultat : response.infosBac.codeMassarResultat,
        ConfirmCodeMassarResultat : response.infosBac.confirmCodeMassarResultat,
        IdCrypte: response.infosBac.idCrypte,
        CodeMassarCodeNationalEtudiant:
          response.infosBac.codeMassarCodeNationalEtudiant,
        ConfirmCodeMassarCodeNationalEtudiant:
          response.infosBac.codeMassarCodeNationalEtudiant,
        TypeDeBac: response.infosBac.typeDeBac,
        AvezVousObtenuVotreDiplome:
          response.infosBac.avezVousObtenuVotreDiplome,
        NoteBacRegional: response.infosBac.noteBacRegional,
        AutreVilleLycee: response.infosBac.autreVilleLycee,
        Math1erBacSemestre1: response.infosBac.math1erBacSemestre1,
        Math1erBacSemestre2: response.infosBac.math1erBacSemestre2,
        Math2erBacSemestre1: response.infosBac.math2erBacSemestre1,
        Math2erBacSemestre2: response.infosBac.math2erBacSemestre2,
        Maths1ErBacTrim3: response.infosBac.maths1ErBacTrim3,
        Maths2EmeBacTrim3: response.infosBac.maths2EmeBacTrim3,
        Physique1ErBacTrim3: response.infosBac.physique1ErBacTrim3,
        Physique2EmeBacTrim3: response.infosBac.physique2EmeBacTrim3,
        Lycee: response.infosBac.lycee,
        MoyGen2EmeAnneeCycleLycee: response.infosBac.moyGen2EmeAnneeCycleLycee,
        TypeDEtablissement: response.infosBac.typeDEtablissement,
        PaysDuLycee: response.infosBac.paysDuLycee,
        AnneeDObtentionDuBaccalaureatOuEspere:
          response.infosBac.anneeDObtentionDuBaccalaureatOuEspere,
        MoyGenDuBac: response.infosBac.moyGenDuBac,
        DomaineDuBaccalaureat: response.infosBac.domaineDuBaccalaureat,
        NoteDuBacNational: response.infosBac.noteDuBacNational,
        VilleDuLycee: response.infosBac.villeDuLycee,
        NomDuLycee: response.infosBac.nomDuLycee,
        BaremeDeNotationAuBac: response.infosBac.baremeDeNotationAuBac,
        SpecificationDuBaremeDeBac:
          response.infosBac.specificationDuBaremeDeBac,
        Specialite1: response.infosBac.specialite1,
        Specialite2: response.infosBac.specialite2,
        MathsExpertOption: response.infosBac.mathsExpertOption,
        NoteSpecialite1: response.infosBac.noteSpecialite1,
        NoteSpecialite2: response.infosBac.noteSpecialite2,
        NoteMathsExpertOption: response.infosBac.noteMathsExpertOption,
        MathsNational: response.infosBac.mathsNational,
        Physique1erBacSemestre1: response.infosBac.physique1erBacSemestre1,
        Physique1erBacSemestre2: response.infosBac.physique1erBacSemestre2,
        Physique2erBacSemestre1: response.infosBac.physique2erBacSemestre1,
        Physique2erBacSemestre2: response.infosBac.physique2erBacSemestre2,
        PhysiqueNational: response.infosBac.physiqueNational,
        PrecisezTypeDiplome: response.infosBac.precisezTypeDiplome,
        TypeBacAutre: response.infosBac.typeBacAutre,
        Moy1erAnneeBac: response.infosBac.moy1erAnneeBac,
        Pp: response.infosBac.pp,
        InscriptionUM6P: response.infosBac.inscriptionUM6P,
        MoyenneCcAnneeBac: response.infosBac.moyenneCcAnneeBac,
        MoyenneSem1Trim1Bac: response.infosBac.moyenneSem1Trim1Bac,
        SystemeNotationBac: response.infosBac.systemeNotationBac,
      },

      InfosMaster: {
        IdCrypte: response.infosMaster.idCrypte,
        VotreDiplomeActuelEnCoursOuObtenu:
          response.infosMaster.votreDiplomeActuelEnCoursOuObtenu,
        AvezVousObtenuVotreDiplome:
          response.infosMaster.avezVousObtenuVotreDiplome,
        PaysObtentionDuDiplome: response.infosMaster.paysObtentionDuDiplome,
        VilleObtentionDuDiplome: response.infosMaster.villeObtentionDuDiplome,
        NomEtablissement: response.infosMaster.nomEtablissement,
        PublicPrive: response.infosMaster.publicPrive,
        Majeure: response.infosMaster.majeure,
        DateEntree: this.ConvertDateApiToDateVue(
          response.infosMaster.dateEntree
        ),
        DateDeFinOuEspere: this.ConvertDateApiToDateVue(
          response.infosMaster.dateDeFinOuEspere
        ),
        NoteFinaleDuDiplome: response.infosMaster.noteFinaleDuDiplome,
        VotreEchelleDeNotation: response.infosMaster.votreEchelleDeNotation,
        VeuillezPreciserVotreEchelleDeNotation:
          response.infosMaster.veuillezPreciserVotreEchelleDeNotation,
        Sem1NoteFinale: response.infosMaster.sem1NoteFinale,
        Sem1NbDeRattrapage: response.infosMaster.sem1NbDeRattrapage,
        Sem2NoteFinale: response.infosMaster.sem2NoteFinale,
        Sem2NbDeRattrapage: response.infosMaster.sem2NbDeRattrapage,
        Sem3NoteFinale: response.infosMaster.sem3NoteFinale,
        Sem3NbDeRattrapage: response.infosMaster.sem3NbDeRattrapage,
        Sem4NoteFinale: response.infosMaster.sem4NoteFinale,
        Sem4NbDeRattrapage: response.infosMaster.sem4NbDeRattrapage,
        Annee1TRIM3: response.infosMaster.annee1TRIM3,
        Annee1Trim3NBDeRattrapage:
          response.infosMaster.annee1Trim3NBDeRattrapage,
        Annee2Trim3: response.infosMaster.annee2Trim3,
        Annee2Trim3NBDeRattrapage:
          response.infosMaster.annee2Trim3NBDeRattrapage,
        Sem5NoteFinale: response.infosMaster.sem5NoteFinale,
        Sem5NbDeRattrapage: response.infosMaster.sem5NbDeRattrapage,
        Sem6NoteFinale: response.infosMaster.sem6NoteFinale,
        Sem6NbDeRattrapage: response.infosMaster.sem6NbDeRattrapage,
        Sem7NoteFinale: response.infosMaster.sem7NoteFinale,
        Sem7NbDeRattrapage: response.infosMaster.sem7NbDeRattrapage,
        Sem8NoteFinale: response.infosMaster.sem8NoteFinale,
        Sem8NbDeRattrapage: response.infosMaster.sem8NbDeRattrapage,
        Sem9NoteFinale: response.infosMaster.sem9NoteFinale,
        Sem9NbDeRattrapage: response.infosMaster.sem9NbDeRattrapage,
        Sem10NoteFinale: response.infosMaster.sem10NoteFinale,
        Sem10NbDeRattrapage: response.infosMaster.sem10NbDeRattrapage,
        Sem11NoteFinale: response.infosMaster.sem11NoteFinale,
        Sem11NbDeRattrapage: response.infosMaster.sem11NbDeRattrapage,
        Sem12NoteFinale: response.infosMaster.sem12NoteFinale,
        Sem12NbDeRattrapage: response.infosMaster.sem12NbDeRattrapage,
        Etablissement: response.infosMaster.etablissement,
        Pp: response.infosMaster.pp,
        InscriptionUM6P: response.infosMaster.inscriptionUM6P,
        SystemeNotationPostBac: response.infosMaster.systemeNotationPostBac,
      },
      InfosTuteur: {
        IdCrypte: response.infosTuteur.idCrypte,
        Genre: response.infosTuteur.genre,
        Prenom: response.infosTuteur.prenom,
        Nom: response.infosTuteur.nom,
        Profession: response.infosTuteur.profession,
        NatureDeLaRelation: response.infosTuteur.natureDeLaRelation,
        Tel: response.infosTuteur.tel,
        Email: response.infosTuteur.email,
        MemeAdresseQueLeCandidat: response.infosTuteur.memeAdresseQueLeCandidat,
        Adresse1: response.infosTuteur.adresse1,
        Adresse2: response.infosTuteur.adresse2,
        Pays: response.infosTuteur.pays,
        Region: response.infosTuteur.region,
        Ville: response.infosTuteur.ville,
        CodePostal: response.infosTuteur.codePostal,
        ProvinceMaroc: response.infosTuteur.provinceMaroc,
        InscriptionUM6P: response.infosTuteur.inscriptionUM6P,
      },
      ListeProgrammesUm6p: [],
    };

    Object.assign(this.inscription.TypeDHandicap, response.typeDHandicap);
    Object.assign(this.inscription.Disciplines, response.disciplines);
    this.inscription.DateDeNaissanceFormatee = this.FormatDate(this.inscription.DateDeNaissance);
  },
  // Formater la date pour l'affichage dans le text field
  FormatDate(date) {
    if (!date) return null;

    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  },
  UnFormatDate(date) {
      if (!date){
        return null;
      }

      let dateArray = date.split("/");
      
      // Vérifier si la date contient bien 3 slash.
      if (dateArray.length !== 3){
        return null;
      }

      // Format date attendu dans le date-picker
      let newDate = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;

      // Vérifier que la date est au bon format et valide.
      let tester = moment(newDate, "YYYY-MM-DD", true);
      if (!tester.isValid()) {
        newDate = null;
      }

      return newDate;
    },

  // Compte le nombre de programmes sélectionné
  RecupererProgrammes() {
    this.inscription.ListeProgrammesUm6p = [];
    // boucle sur les niveaux
    this.ListeVueProgrammes.forEach((niv) => {
      // Boucle sur les cluster
      for (const [, value] of Object.entries(niv.programmes)) {
        // Boucle sur les programmes
        value.forEach((programme) => {
          if (programme.isChecked == true) {
            let dto = this.ParamProgrammeToDto(programme);
            if (dto) {
              this.inscription.ListeProgrammesUm6p.push(dto);
            }
          }
        });
      }

    });

    // Trier par N° Ordre
    this.inscription.ListeProgrammesUm6p = this.inscription.ListeProgrammesUm6p.sort((a, b) => a.NoOrdre - b.NoOrdre);
  },

  // Décoche tous les programmes sélectionnés.
  DecocherProgrammes() {
    // boucle sur les niveaux
    this.ListeVueProgrammes.forEach((niv) => {
      // Boucle sur les cluster
      for (const [, value] of Object.entries(niv.programmes)) {
        // Boucle sur les programmes
        value.forEach((programme) => {
          if (programme.isChecked == true) {
            programme.isChecked = false;
          }
        });
      }
    });

    // MAJ de la liste programmes
    this.RecupererProgrammes();
  },

  ParamProgrammeToDto(programme) {
    if (programme) {
      let dto = 
       {
        Actif: programme.actif,
        BourseCompleteAnnuelle: programme.bourseCompleteAnnuelle,
        BourseCompleteMensuelle: programme.bourseCompleteAnnuelle,
        Cluster: {
          Id: programme.cluster.id,
        },
        CodeProgramme: programme.codeProgramme,
        Ecole: programme.ecole,
        IdCrypte: programme.idCrypte,
        MontantMinimumDeBourse: programme.montantMinimumDeBourse,
        NiveauEtude: programme.niveauEtude,
        Label: programme.label,
        IsChecked: programme.isChecked,
        IdProgramme: programme.idProgramme,
        NoOrdre: programme.noOrdre,
        ProgrammeSportif: programme.programmeSportif,
        ListeSpecialitesVue:[],
      };

      programme.listeSpecialitesVue.forEach(s=>{
        let specialite = {
          IsChecked : s.isChecked,
          Label : s.label,
          NoOrdre : s.noOrdre,
          IdCrypte : s.idCrypte,
          IdProgramme : s.idProgramme,
          IdSpecialite : s.idSpecialite,
        }
        dto.ListeSpecialitesVue.push(specialite);
      });

      return dto;
    }
  },

  MapperParamInscription(dto) {
    this.ChoixCycle = dto.choixCycle;
    this.NiveauEtude = dto.cycleSouhaite;
    this.NiveauEtudeFixe = dto.cycleSouhaite;
    this.NiveauEtudeFixeSoumission = dto.cycleSoumission;
    this.Ouvert = dto.ouvert;
    this.MasterSoumission = dto.masterSoumission;
    this.ParalleleSoumission = dto.paralleleSoumission;
    this.ParalleleBacSoumission = dto.paralleleBacSoumission;
    this.IngenieurSoumission = dto.ingenieurSoumission;
    this.PostBacFrSoumission = dto.postBacFrSoumission;
    this.PostBacMaSoumission = dto.postBacMaSoumission;
    this.PostBacAuSoumission = dto.postBacAuSoumission;
    this.InscriptionFermee = dto.inscriptionFermee;
  },
  itemLang: "lang00",
  typeBacMaroccain: 3866,
  displayLabel(typeBac) {
    if (typeBac == this.typeBacMaroccain) {
      return this.label.Moyenne1erAnneBac;
    } else {
      return this.label.Moyenne1erAnneBacFr;
    }
  },
  noteBacMaxAutorise(bareme, specificationDuBaremeDeBac, storeCatalogue){
    let noteBacMaxAutorise;

    if (bareme != storeCatalogue.DataId.BaremBacAutre) 
        {
            let selectedDiplomeId = bareme;
            if (selectedDiplomeId !== null) 
            {
              let selectedDiplome = storeCatalogue.BaremBac.find((d) => d.id === selectedDiplomeId);
              if(selectedDiplome){
                noteBacMaxAutorise = selectedDiplome.lang00;              
              }
            }
        } 
        else 
        {
            noteBacMaxAutorise = parseFloat(specificationDuBaremeDeBac);
        }

    return noteBacMaxAutorise;
  }
};
